<script lang="ts">
    import type {Rec} from 'src/typings';
    import {states} from 'shared/constants';
    import {getInjector, getLocalization} from 'src/core';
    import {onDestroy} from 'svelte';
    import {cleanup} from 'shared/utils/custom-utils';
    import {KpFavouritesButtonPresenter} from './kp-favourites-button.presenter';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let record: Rec;

    const localize = getLocalization();
    const presenter = getInjector().getByClass(KpFavouritesButtonPresenter);

    let showAddButton = false;
    let showRemoveButton = false;
    let isDisabled = true;

    const statesSubscription = presenter.getFavouritesState$().subscribe((state) => {
        isDisabled = state === states.PROCESSING || state === states.INITIAL;
        if (state === states.NORMAL) {
            showAddButton = presenter.canAddToFavourites(record);
            showRemoveButton = presenter.canRemoveFromFavourites(record);
        }
    });

    onDestroy(() => {
        cleanup(statesSubscription);
    });

    const handleAddToFavourites = () => {
        presenter.addToFavourites(record);
    };

    const removeFromFavourites = () => {
        presenter.removeFromFavourites(record);
    };
</script>

{#if showAddButton}
    <KpButton buttonSize="sm"
              additionalClasses="add-to-favourites-button"
              on:click={handleAddToFavourites}
              noWrap
              isBlock>

        <slot name="add">
            <IconedContent icon="heart">
                {localize(/* @kp-localization recordCollections.favourites.AddToFavourites */ 'recordCollections.favourites.AddToFavourites')}
            </IconedContent>
        </slot>
    </KpButton>
{/if}

{#if showRemoveButton}
    <KpButton buttonSize="sm"
              additionalClasses="remove-from-favourites-button"
              on:click={removeFromFavourites}
              {isDisabled}
              noWrap
              isBlock>

        <slot name="remove">
            <IconedContent icon="heart" iconVariant="solid">
                {localize(/* @kp-localization recordCollections.favourites.RemoveFromFavourites */ 'recordCollections.favourites.RemoveFromFavourites')}
            </IconedContent>
        </slot>
    </KpButton>
{/if}